import React from "react";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getClientDetails } from "../../storeSlices/dataSlice";
function Clients() {
  const [details, setdetails] = useState({
    name: "",
    gst_no: "",
    phone: "",
    address_id: "",
    pan_card: "",
  });

  const dispatch = useDispatch();
  const [clientdetails, setclientdetails] = useState([]);
  const driver = useSelector((state) => state.dataReducer.drivers);
  useEffect(() => {
    // dispatch(getClientDetails());
    setclientdetails(driver);
  }, []);

  const handleChange = (e) => {
    setdetails({ ...details, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log(details);
    // const response = await fetch(`http://localhost:5000/party/`, {
    // `https://tame-jade-earthworm-belt.cyclic.app/party/`,
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/party/`,

      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
        },
        body: JSON.stringify(details),
      }
    );
    const json = await response.json();
    console.log(json);

    const inputfield = document.getElementsByClassName("entry");
    Object.entries(inputfield).forEach((element) => {
      element[1].value = "";
    });
  };
  return (
    <div className="chalan-form-container">
      <form className="chalan-form" onSubmit={handleSubmit} id="bill-form">
        <label>
          Name
          <input
            className="entry"
            type="text"
            name="name"
            value={details.name}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Pan-Card Number
          <input
            className="entry"
            type="text"
            name="pan_card"
            value={details.pan_card}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          GST Number:
          <input
            className="entry"
            type="text"
            name="gst_no"
            value={details.gst_no}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Phone Number:
          <input
            className="entry"
            type="text"
            name="phone"
            value={details.phone}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Address:
          <input
            className="entry"
            type="text"
            name="address_id"
            value={details.address_id}
            onChange={handleChange}
          />
        </label>
        <br />

        <br />
        <input className="generate" type="submit" value="Add Client" />
      </form>
    </div>
  );
}

export default Clients;
